import React from "react";
import useEntity from "../../../hooks/useCordwoodHistory";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import { CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./CordwoodHistoryListHeader";
import EntityListSearch from "./CordwoodHistoryListSearch";
import {useLocation} from "react-router";
import CordwoodHistoryListPagination from "./CordwoodHistoryListPagination";
import * as Api from "../../../apis/CordwoodHistory.api";
import { CordwoodHistory } from "../../../types/models/CordwoodHistory";
import { PrimaryCordwoodHistory } from "../../../types/models/CordwoodHistory";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import CordwoodLink from "../../../../timber/components/cordwood/CordwoodDetail/CordwoodLink";
import CordwoodName from "../../../../timber/components/cordwood/CordwoodDetail/CordwoodName";
import TimberStorageLink from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageLink";
import TimberStorageName from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import LocationLink from "../../../../location/components/location/LocationDetail/LocationLink";
import LocationName from "../../../../location/components/location/LocationDetail/LocationName";
import CuttingLink from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";
import CuttingName from "../../../../timber/components/cutting/CuttingDetail/CuttingName";
import ShipmentLink from "../../../../timber/components/shipment/ShipmentDetail/ShipmentLink";
import ShipmentName from "../../../../timber/components/shipment/ShipmentDetail/ShipmentName";
import TimberTypeLink from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeLink";
import TimberTypeName from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import TimberClassLink from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassLink";
import TimberClassName from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import { PrimaryCordwood } from "../../../../timber/types/models/Cordwood";
import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import CordwoodHistoryListItemTools from "./CordwoodHistoryListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    cordwoodId?: ID,
    action?: string,
    };

const CordwoodHistoryListItem = (props: IProps) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('CordwoodHistory')

    
    
    
    
    const [, setSearchInputValue, searchInputTerm] = useSearchDebounce();
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          Api.useGetCordwoodHistoryPresentationQuery({
                  list: { page, pageSize },
                  filter: {
                    cordwoodIdRefs: (PrimaryCordwood.fromQuery(query.cordwoodId)) ? [ PrimaryCordwood.fromQuery(query.cordwoodId) ] : [],
                    // for now not supported to query here other types
                    cordwoodId: null,
                    action: searchInputTerm || '',
                    actionOr: true,
                    orderBys,
                  },
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: CordwoodHistory) => routeLocation.pathname.endsWith('cordwood-histories') ?
        `${PrimaryCordwoodHistory.fromEntity(entity).toPath()}`
        :
        `cordwood-histories/${PrimaryCordwoodHistory.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: CordwoodHistory) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                <EntityListSearch
                    setSearchInputValue={setSearchInputValue}
                    
                    query={query}
                    refetch={refetch}
                />
                <TableContainer>

                    

                    

                    

                    

                    
        
                    
                    {isSmallScreen ?
                        <Table stickyHeader data-testid="CordwoodHistory-entity-list" size="small">
                            <TableHead>
                                <SmallTableHeaderRow>
                                    
                                        
                                        
                                    

                                    
                                <StyledTableCell align="left">
                                    
                                    <TableSortLabel
                                        active={ orderBys.find((item) => item.name === 'cordwoodId') }
                                        direction={ orderBys.find((item) => item.name === 'cordwoodId')?.direction || 'asc' }
                                        onClick={() => toggleOrder('cordwoodId')}
                                    >
                                    
                                        <Trans>Cordwood</Trans>
                                    
                                    </TableSortLabel>
                                    
                                </StyledTableCell>
                        
                    
                                    
                                    
                                        
                                        
                                    

                                    
                                <StyledTableCell align="left">
                                    
                                    <TableSortLabel
                                        active={ orderBys.find((item) => item.name === 'shipmentId') }
                                        direction={ orderBys.find((item) => item.name === 'shipmentId')?.direction || 'asc' }
                                        onClick={() => toggleOrder('shipmentId')}
                                    >
                                    
                                        <Trans>Shipment</Trans>
                                    
                                    </TableSortLabel>
                                    
                                </StyledTableCell>
                        
                    
                                    
                                    
                            <StyledTableCell align="center">
                                
                                <TableSortLabel
                                    active={ orderBys.find((item) => item.name === 'updatedAt') }
                                    direction={ orderBys.find((item) => item.name === 'updatedAt')?.direction || 'asc' }
                                    onClick={() => toggleOrder('updatedAt')}
                                >
                                
                                    <Trans>Updated At</Trans>
                                
                                </TableSortLabel>
                                
                            </StyledTableCell>
                        
                    
                                    
                                    
                                </SmallTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <SmallTableRow
                                        hover={true}
                                        key={ PrimaryCordwoodHistory.fromEntity(item).toPath() }
                                    >
                                        
                        
                        
                            
                            
                        

                        <TableCell
                            scope="row"
                            align="left"
                        >
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                                <Typography component="div" sx={ { fontWeight: 'bold', } }>
                                    { item.cordwoodId ?
                                        <>
                                            
                        
                        
                        <CordwoodName id={ item.cordwoodId }/>
                        
                        
                    
                                        </>
                                        :
                                        '-'
                                    }
                                </Typography>
                                
                            
                                <Typography component="div" variant="body1">
                                    { item.action &&
                                            
                                <>
                                    <Trans>Action</Trans>:&nbsp;
                                    
                                    
                        
                        { item.action || '-' }
                        
                    
                                </>
                                
                                }
                                </Typography>
                                
                            
                            </Link>
                        </TableCell>

                    
                        
                    
                        
                        
                            
                            
                        

                        <TableCell
                            scope="row"
                            align="left"
                        >
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                                <Typography component="div" sx={ { fontWeight: 'bold', } }>
                                    { item.shipmentId ?
                                        <>
                                            
                        
                        
                        <ShipmentName id={ item.shipmentId }/>
                        
                        
                    
                                        </>
                                        :
                                        '-'
                                    }
                                </Typography>
                                
                            
                                <Typography component="div" variant="body1">
                                    { item.state &&
                                            
                                <>
                                    <Trans>State</Trans>:&nbsp;
                                    
                                    
                        
                        { toStringShipmentState(item.state) || '-' }
                        
                    
                                </>
                                
                                }
                                </Typography>
                                
                            
                                <Typography component="div" variant="body1">
                                    { item.commited &&
                                            
                                <>
                                    <Trans>Commited</Trans>:&nbsp;
                                    
                                    
                        
                        { item.commited ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }
                        
                    
                                </>
                                
                                }
                                </Typography>
                                
                            
                            </Link>
                        </TableCell>

                    
                        
                    
                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        {displayDateTime(item.updatedAt) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                        
                    
                        
                    
                                    </SmallTableRow>
                                ))}
                            </TableBody>
                        </Table>
                        :
                    
                        <Table stickyHeader data-testid="CordwoodHistory-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    { query.cordwoodId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'cordwoodId') }
                                                direction={ orderBys.find((item) => item.name === 'cordwoodId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('cordwoodId')}
                                            >
                                            
                                                <Trans>Cordwood</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'action') }
                                            direction={ orderBys.find((item) => item.name === 'action')?.direction || 'asc' }
                                            onClick={() => toggleOrder('action')}
                                        >
                                        
                                            <Trans>Action</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'contextHistory') }
                                            direction={ orderBys.find((item) => item.name === 'contextHistory')?.direction || 'asc' }
                                            onClick={() => toggleOrder('contextHistory')}
                                        >
                                        
                                            <Trans>Context History</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'updatedAt') }
                                            direction={ orderBys.find((item) => item.name === 'updatedAt')?.direction || 'asc' }
                                            onClick={() => toggleOrder('updatedAt')}
                                        >
                                        
                                            <Trans>Updated At</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'internalKey') }
                                            direction={ orderBys.find((item) => item.name === 'internalKey')?.direction || 'asc' }
                                            onClick={() => toggleOrder('internalKey')}
                                        >
                                        
                                            <Trans>IK</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'timberKey') }
                                            direction={ orderBys.find((item) => item.name === 'timberKey')?.direction || 'asc' }
                                            onClick={() => toggleOrder('timberKey')}
                                        >
                                        
                                            <Trans>Timber Key</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    { query.storageId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'storageId') }
                                                direction={ orderBys.find((item) => item.name === 'storageId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('storageId')}
                                            >
                                            
                                                <Trans>Timber Storage</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    { query.locationId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                                <Trans>Location</Trans>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    
                                    
                                    { query.shipmentId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'shipmentId') }
                                                direction={ orderBys.find((item) => item.name === 'shipmentId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('shipmentId')}
                                            >
                                            
                                                <Trans>Shipment</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="right">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'volume') }
                                            direction={ orderBys.find((item) => item.name === 'volume')?.direction || 'asc' }
                                            onClick={() => toggleOrder('volume')}
                                        >
                                        
                                            <Trans>Volume</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'state') }
                                            direction={ orderBys.find((item) => item.name === 'state')?.direction || 'asc' }
                                            onClick={() => toggleOrder('state')}
                                        >
                                        
                                            <Trans>State</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'measurementType') }
                                            direction={ orderBys.find((item) => item.name === 'measurementType')?.direction || 'asc' }
                                            onClick={() => toggleOrder('measurementType')}
                                        >
                                        
                                            <Trans>MU</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    { query.timberTypeId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'timberTypeId') }
                                                direction={ orderBys.find((item) => item.name === 'timberTypeId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('timberTypeId')}
                                            >
                                            
                                                <Trans>Timber Type</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    { query.classId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'classId') }
                                                direction={ orderBys.find((item) => item.name === 'classId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('classId')}
                                            >
                                            
                                                <Trans>Timber Class</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'commited') }
                                            direction={ orderBys.find((item) => item.name === 'commited')?.direction || 'asc' }
                                            onClick={() => toggleOrder('commited')}
                                        >
                                        
                                            <Trans>Commited</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryCordwoodHistory.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        { query.cordwoodId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <CordwoodLink id={ item.cordwoodId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.action || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.contextHistory || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        {displayDateTime(item.updatedAt) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.internalKey || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.timberKey || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        { query.storageId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <TimberStorageLink id={ item.storageId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        { query.locationId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <LocationLink id={ item.locationId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                        { query.shipmentId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <ShipmentLink id={ item.shipmentId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="right"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        {fixedFormat(item.volume) || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { toStringShipmentState(item.state) || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { toStringCordwoodMeasurementType(item.measurementType) || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        { query.timberTypeId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <TimberTypeLink id={ item.timberTypeId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        { query.classId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <TimberClassLink id={ item.classId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.commited ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <CordwoodHistoryListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                    
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No Cordwood Histories</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <CordwoodHistoryListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching,isSmallScreen, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default CordwoodHistoryListItem;
